import '../assets/css/nav-css.css'

const Nav = () => {

    return (
        <nav class="navbar">
            <div class="brand">PySpective</div>
        </nav>
    );

};

export default Nav;